import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import FormikProvider from '../../../shared/forms/formikProvider.component';

import {
  string as yupString,
} from 'yup';

import InputFormik from '../../../shared/forms/input/inputFormik.component';
import TestCustomReportQueryParamModal from './testCustomReportQueryParamModal.component';

const getSchema = params => params.map(param => (
  {
    name: param,
    component: InputFormik,
    meta: { label: param },
    options: { yupType: yupString() },
  }
));

const createParamValues = params => params.reduce((obj, param) => {
  obj[param] = '';
  return obj;
}, {});

const TestCustomReportQueryParamModalContainer = ({
  params,
  hideModal,
  isVisible,
  onSubmitParams,
  isOpenForSubmit,
}) => {
  const schema = useMemo(() => params ? getSchema(params) : [], [params]);
  const entityToEdit = useMemo(() => params ? createParamValues(params) : {}, [params]);

  const renderModal = useCallback(
    ({ formik, schema }) => <TestCustomReportQueryParamModal
      formik={formik}
      schema={schema}
      hideModal={hideModal}
      isVisible={isVisible}
    />,
    [hideModal, isVisible]
  );

  const onSubmit = useCallback(formValues => {
    onSubmitParams(formValues, { isOpenForSubmit });
  }, [onSubmitParams, isOpenForSubmit]);

  return (
    params
      ? <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={onSubmit}
        render={renderModal}
      /> : null
  );
};

TestCustomReportQueryParamModalContainer.propTypes = {
  hideModal: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onSubmitParams: PropTypes.func.isRequired,
  params: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  isOpenForSubmit: PropTypes.bool.isRequired,
};

export default TestCustomReportQueryParamModalContainer;
